import { render } from "./LinkedShippingOrders.vue?vue&type=template&id=bc7e9a6c"
import script from "./LinkedShippingOrders.vue?vue&type=script&lang=js"
export * from "./LinkedShippingOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__